<footer class="footer">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 text-center text-lg-end version-label-text">
				<p>Versión 0.10.9</p>
			</div>
		</div>
	</div>
</footer>